import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { t } = useTranslation();

  return (
    <Stack alignItems="flex-start" spacing={2}>
      <Typography variant="h4" fontSize={24}>
        {t('distribution:distributionInfoBlock:title')}
      </Typography>
      <Typography variant="body1">
        {t('distribution:distributionInfoBlock:subtitle')}
      </Typography>
    </Stack>
  );
};

export default Header;
